<template>
  <section id="dashboard-report-brand">
    <b-row class="match-height">
      <!-- Settings Table Card -->
      <b-col>
        <report-brand-table :table-data="data" />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

import ReportBrandTable from './ReportBrandTable.vue'

export default {
  components: {
    BRow,
    BCol,
    ReportBrandTable,
  },
  data() {
    return {
      data: [],
    }
  },
  // created() {
  //   this.$http.post('/crawler/list')
  //     .then(response => {
  //       this.data = response.data
  //     })
  // },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
